import React, { useState } from "react";
import "../../style/pages/categoriespage/rifles.css";
import { useNavigate } from "react-router-dom";
import Header from "../../component/Header.jsx";

import r1 from "../../media3/categories/r1.png";
import r2 from "../../media3/categories/r2.png";
import r3 from "../../media3/categories/r3.png";
import r4 from "../../media3/categories/r4.png";
import r5 from "../../media3/categories/r5.png";
import r6 from "../../media3/categories/r6.png";
import r7 from "../../media3/categories/r7.png";
import r8 from "../../media3/categories/r8.png";
import r9 from "../../media3/categories/r9.png";
import r10 from "../../media3/categories/r10.png";
import r11 from "../../media3/categories/r11.png";
import r12 from "../../media3/categories/r12.png";
import r13 from "../../media3/categories/r13.png";
import r14 from "../../media3/categories/r14.png";
import r15 from "../../media3/categories/r15.png";
import r16 from "../../media3/categories/r16.png";
import r17 from "../../media3/categories/r17.png";
import r18 from "../../media3/categories/r18.png";
import r19 from "../../media3/categories/r19.png";
import r20 from "../../media3/categories/r20.png";
import r21 from "../../media3/categories/r21.png";
import r22 from "../../media3/categories/r22.png";
import r23 from "../../media3/categories/r23.png";
import r24 from "../../media3/categories/r24.png";

import r from "../../media3/categories/ar.png";

import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

// Dummy data
// export const riflesData = [
//   { id: 1, name: "AK-47 | Slalom", img: r1, price: 61, maxPrice: 122, color: "red", rating: 4, rarity: "Restricted", orderedBy: "Popularity", currency: "USD" },
//   { id: 2, name: "M4A4 | Blaze", img: r2, price: 80, maxPrice: 150, color: "green", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD" },
//   { id: 3, name: "AWP | Fade", img: r3, price: 95, maxPrice: 160, color: "black", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD" },
//   { id: 4, name: "M4A1-S | Orion", img: r4, price: 120, maxPrice: 180, color: "green", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD" },
//   { id: 5, name: "Galil AR | See Ya Later", img: r5, price: 70, maxPrice: 125, color: "black", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD" },
//   { id: 6, name: "FAMAS | Hyper Beast", img: r6, price: 90, maxPrice: 140, color: "black", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD" },
//   { id: 7, name: "SG 553 | Fuel Injector", img: r7, price: 110, maxPrice: 160, color: "orange", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD" },
//   { id: 8, name: "AUG | Melondrama", img: r8, price: 60, maxPrice: 120, color: "blue", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD" },
//   { id: 9, name: "SCAR-20 | Llama Cannon", img: r9, price: 75, maxPrice: 130, color: "white", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD" },
//   { id: 10, name: "M4A1-S | Kill Confirmed", img: r10, price: 145, maxPrice: 200, color: "black", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD" },
//   { id: 11, name: "AK-47 | Bullet Queen", img: r11, price: 88, maxPrice: 150, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD" },
//   { id: 12, name: "FAMAS | Handgun", img: r12, price: 55, maxPrice: 110, color: "purple", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD" },
//   { id: 13, name: "SG 553 | Avalanche", img: r13, price: 68, maxPrice: 125, color: "blue", rating: 4, rarity: "Restricted", orderedBy: "Newest", currency: "USD" },
//   { id: 14, name: "AWP | Xiangliu", img: r14, price: 92, maxPrice: 160, color: "green", rating: 4, rarity: "Classified", orderedBy: "Price", currency: "USD" },
//   { id: 15, name: "Galil AR | Muertos", img: r15, price: 63, maxPrice: 120, color: "black", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD" },
//   { id: 16, name: "AUG | Angry Mob", img: r16, price: 85, maxPrice: 140, color: "blue", rating: 5, rarity: "Classified", orderedBy: "Rating", currency: "USD" },
//   { id: 17, name: "SCAR-20 | Cobra Strike", img: r17, price: 78, maxPrice: 130, color: "red", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD" },
//   { id: 18, name: "M4A4 | Crazy 8", img: r18, price: 59, maxPrice: 110, color: "yellow", rating: 2, rarity: "Restricted", orderedBy: "Popularity", currency: "USD" },
//   { id: 19, name: "M4A1-S | Ticket to Hell", img: r19, price: 99, maxPrice: 160, color: "red", rating: 5, rarity: "Classified", orderedBy: "Price", currency: "USD" },
//   { id: 20, name: "AK-47 | Water Elemental", img: r20, price: 115, maxPrice: 175, color: "red", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD" },
//   { id: 21, name: "Galil AR | Asiimov", img: r21, price: 102, maxPrice: 155, color: "black", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD" },
//   { id: 22, name: "AWP | Pole Position", img: r22, price: 66, maxPrice: 125, color: "orange", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD" },
//   { id: 23, name: "SG 553 | Isaac", img: r23, price: 74, maxPrice: 130, color: "black", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD" },
//   { id: 24, name: "AUG | Boost Protocol", img: r24, price: 97, maxPrice: 160, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD" }
// ];

export const riflesData = [
  {
    id: 1,
    name: "AK-47 | Slalom",
    img: r1,
    price: 61,
    maxPrice: 122,
    color: "red",
    rating: 4,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A red and white ski-themed paint job with slalom gates and snow trails. Perfect for carving through enemies with precision and speed."
  },
  {
    id: 2,
    name: "M4A4 | Blaze",
    img: r2,
    price: 80,
    maxPrice: 150,
    color: "green",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Price",
    currency: "USD",
    description: "It has been painted with a chrome base coat and candied in transparent flame-colored paints. The flame pattern is semi-transparent, allowing the chrome underneath to shine through in a blazing inferno."
  },
  {
    id: 3,
    name: "AWP | Fade",
    img: r3,
    price: 95,
    maxPrice: 160,
    color: "black",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "The body of the AWP has been airbrushed with a vibrant gradient of purple, pink, and yellow. The colors blend seamlessly, creating a stunning fade effect that shifts with every angle."
  },
  {
    id: 4,
    name: "M4A1-S | Orion",
    img: r4,
    price: 120,
    maxPrice: 180,
    color: "green",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Newest",
    currency: "USD",
    description: "A silver and black space-themed design with constellation patterns. The receiver features a deep blue galaxy finish with glowing stars, inspired by the Orion nebula."
  },
  {
    id: 5,
    name: "Galil AR | See Ya Later",
    img: r5,
    price: 70,
    maxPrice: 125,
    color: "black",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A custom paint job featuring a green mechanical alligator with a menacing grin. The phrase 'See Ya Later' is scrawled across the receiver in graffiti style."
  },
  {
    id: 6,
    name: "FAMAS | Hyper Beast",
    img: r6,
    price: 90,
    maxPrice: 140,
    color: "black",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A vibrant, multicolored beast with sharp teeth and glowing eyes covers the entire weapon. The design pulses with neon energy, making it a true hyper beast on the battlefield."
  },
  {
    id: 7,
    name: "SG 553 | Fuel Injector",
    img: r7,
    price: 110,
    maxPrice: 160,
    color: "orange",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Price",
    currency: "USD",
    description: "A high-octane orange and black racing theme with exposed mechanical parts and glowing fuel lines. It looks like it was ripped straight from a modified street racer."
  },
  {
    id: 8,
    name: "AUG | Melondrama",
    img: r8,
    price: 60,
    maxPrice: 120,
    color: "blue",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "The AUG is painted with a playful watermelon pattern. Green rind, pink flesh, and black seeds create a refreshing and ironic long-range loadout."
  },
  {
    id: 9,
    name: "SCAR-20 | Llama Cannon",
    img: r9,
    price: 75,
    maxPrice: 130,
    color: "white",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Newest",
    currency: "USD",
    description: "A cartoon llama wearing sunglasses and a bandana is painted across the barrel. The phrase 'Llama Cannon' is boldly displayed — perfect for players with a sense of humor."
  },
  {
    id: 10,
    name: "M4A1-S | Kill Confirmed",
    img: r10,
    price: 145,
    maxPrice: 200,
    color: "black",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Price",
    currency: "USD",
    description: "A dark, blood-splattered design with a skull and crossbones. The words 'Kill Confirmed' are etched into the receiver, leaving no doubt about its lethal intent."
  },
  {
    id: 11,
    name: "AK-47 | Bullet Queen",
    img: r11,
    price: 88,
    maxPrice: 150,
    color: "yellow",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A golden crown and bullet casing dress adorn a fierce female figure. She rules the battlefield with style, power, and unapologetic dominance."
  },
  {
   id: 12,
    name: "AK-47 | Bullet Queen",
    img: r12,
    price: 88,
    maxPrice: 150,
    color: "yellow",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A golden crown and bullet casing dress adorn a fierce female figure. She rules the battlefield with style, power, and unapologetic dominance."
  },
  {
    id: 13,
    name: "SG 553 | Avalanche",
    img: r13,
    price: 68,
    maxPrice: 125,
    color: "blue",
    rating: 4,
    rarity: "Restricted",
    orderedBy: "Newest",
    currency: "USD",
    description: "An icy blue and white avalanche pattern sweeps across the weapon. Snow-capped peaks and frozen debris give it a cold, unstoppable feel."
  },
  {
    id: 14,
    name: "AWP | Xiangliu",
    img: r14,
    price: 92,
    maxPrice: 160,
    color: "green",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Price",
    currency: "USD",
    description: "A custom paint job with nine purple and gold snakes has been applied. Inspired by the mythical Xiangliu, it warns: Beware the rising tide."
  },
  {
    id: 15,
    name: "Galil AR | Muertos",
    img: r15,
    price: 63,
    maxPrice: 120,
    color: "black",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A Day of the Dead-inspired design with sugar skulls, roses, and vibrant red patterns. Celebrates life and death in equal measure."
  },
  {
    id: 16,
    name: "AUG | Angry Mob",
    img: r16,
    price: 85,
    maxPrice: 140,
    color: "blue",
    rating: 5,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A chaotic scene of angry protesters with torches and pitchforks. The mob is coming — and they’re not here to negotiate."
  },
  {
    id: 17,
    name: "SCAR-20 | Cobra Strike",
    img: r17,
    price: 78,
    maxPrice: 130,
    color: "red",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Newest",
    currency: "USD",
    description: "A massive cobra strikes across the entire weapon. Red scales and venomous eyes create a deadly, symmetrical threat from long range."
  },
  {
    id: 18,
    name: "M4A4 | Crazy 8",
    img: r18,
    price: 59,
    maxPrice: 110,
    color: "yellow",
    rating: 2,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A graffiti-style '8' ball with dice, cards, and flames. For the gambler who plays Russian roulette with style."
  },
  {
    id: 19,
    name: "M4A1-S | Ticket to Hell",
    img: r19,
    price: 99,
    maxPrice: 160,
    color: "red",
    rating: 5,
    rarity: "Classified",
    orderedBy: "Price",
    currency: "USD",
    description: "A one-way ticket stamped in blood-red ink. Demons, flames, and a torn boarding pass lead straight to the underworld."
  },
  {
    id: 20,
    name: "AK-47 | Water Elemental",
    img: r20,
    price: 115,
    maxPrice: 175,
    color: "red",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Newest",
    currency: "USD",
    description: "A translucent blue water spirit flows across the receiver. Waves, droplets, and glowing eyes give life to the elemental force within."
  },
  {
    id: 21,
    name: "Galil AR | Asiimov",
    img: r21,
    price: 102,
    maxPrice: 155,
    color: "black",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Rating",
    currency: "USD",
    description: "A futuristic white, black, and orange geometric pattern. The iconic Asiimov design represents cutting-edge technology and precision."
  },
  {
    id: 22,
    name: "AWP | Pole Position",
    img: r22,
    price: 66,
    maxPrice: 125,
    color: "orange",
    rating: 3,
    rarity: "Restricted",
    orderedBy: "Popularity",
    currency: "USD",
    description: "A racing-inspired livery with checkered flags, sponsor logos, and aerodynamic lines. Built for speed and first-place finishes."
  },
  {
    id: 23,
    name: "SG 553 | Isaac",
    img: r23,
    price: 74,
    maxPrice: 130,
    color: "black",
    rating: 4,
    rarity: "Classified",
    orderedBy: "Newest",
    currency: "USD",
    description: "A sci-fi design with circuit boards, glowing blue nodes, and holographic text. Inspired by advanced AI and digital evolution."
  },
  {
    id: 24,
    name: "AUG | Boost Protocol",
    img: r24,
    price: 97,
    maxPrice: 160,
    color: "blue",
    rating: 5,
    rarity: "Covert",
    orderedBy: "Price",
    currency: "USD",
    description: "A high-tech military prototype with hazard stripes, warning labels, and classified markings. Access granted: Level 5 clearance required."
  }
];

const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function Rifles({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
    const [selectedRarity, setSelectedRarity] = useState(null);
  const [selectedOrderBy, setSelectedOrderBy] = useState(null);

  const navigate = useNavigate();

  // Filtering
  let filteredRifles = riflesData.filter((rifle) => {
    const inPrice = rifle.price >= priceRange[0] && rifle.price <= priceRange[1];
    const inColor = selectedColors.length === 0 || selectedColors.includes(rifle.color);
     const inRarity = !selectedRarity || selectedRarity === "Any" || rifle.rarity === selectedRarity;
  return inPrice && inColor && inRarity ;
  });

  // Add sorting
if (selectedOrderBy) {
  filteredRifles = [...filteredRifles].sort((a, b) => {
    switch (selectedOrderBy) {
      case "Price":
        return a.price - b.price;
      case "Rating":
        return b.rating - a.rating;
      case "Popularity":
        return a.id - b.id;
      case "Newest":
        return b.id - a.id;
      default:
        return 0;
    }
  });
}


  // Handlers
  const handlePriceChange = (e, idx) => {
    const newRange = [...priceRange];
    newRange[idx] = Number(e.target.value);
    setPriceRange(newRange);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };

  
const handleRarityChange = (rarity) => {
  setSelectedRarity(rarity === selectedRarity ? null : rarity);
};

const handleOrderByChange = (orderBy) => {
  setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
};

  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };

    const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };
  
  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
      <div className="categories-page">
      <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
        <Filter
          openFilter={openFilter}
          toggleSection={toggleSection}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          selectedColors={selectedColors}
          handleColorChange={handleColorChange}
          selectedRating={selectedRating}
          handleRatingChange={handleRatingChange}
          colors={colors}
          ratings={ratings}
                      selectedRarity={selectedRarity}
  handleRarityChange={handleRarityChange}
  selectedOrderBy={selectedOrderBy}
  handleOrderByChange={handleOrderByChange}
        />
        <ItemGrid
          items={filteredRifles}
          categoryImage={r}
          categoryAlt="CZ75-Auto"
          categoryTitle="SG 553 | Fuel Injector"
          categoryDescription="Explore all Rifle skins for CS2. Designed for accuracy and power, rifles dominate mid-to-long range fights — where one clean shot can change the game."
          onItemClick={handleNavigate}
            isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
        />
      </div>
    </div>
  );
}

export default Rifles;